"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _themeGet = _interopRequireDefault(require("@styled-system/theme-get"));

var _Box = _interopRequireDefault(require("../Box"));

var _theme = _interopRequireDefault(require("../../theme"));

var _Typography = require("../Typography");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function getInitials(name) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '?';
  if (!name || typeof name !== 'string') return fallback;
  return name.replace(/\s+/, ' ').split(' ') // Repeated spaces results in empty strings
  .slice(0, 2).map(function (v) {
    return v && v[0].toUpperCase();
  }) // Watch out for empty strings
  .join('');
} // http://erlycoder.com/49/javascript-hash-functions-to-convert-string-into-integer-hash-


function hashCode(s) {
  var str = String(s);
  var hash = 0;

  var _char;

  if (str.trim().length === 0) return hash;

  for (var i = 0; i < str.length; i++) {
    _char = str.charCodeAt(i);
    hash = (hash << 5) - hash + _char; // Convert to 32bit integer

    hash &= hash;
  }

  return Math.abs(hash);
}

var Wrap = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Avatar__Wrap",
  componentId: "sc-1uizhw9-0"
})(["display:inline-flex;align-items:center;justify-content:center;position:relative;vertical-align:middle;border-radius:100px;overflow:hidden;background-color:", ";color:", ";img{border-radius:100px;}", ""], function (props) {
  return props.src ? 'white' : (0, _themeGet["default"])('colors.neutral.400')(props);
}, (0, _themeGet["default"])('colors.neutral.100'), function (props) {
  return props.src && "\n      &:after {\n        border-radius: 100px;\n        content: '';\n        width: 100%;\n        height: 100%;\n        position: absolute;\n        top: 0;\n        left: 0;\n        box-shadow: 0 0 0 1px hsla(0, 0%, 0%, 0.1) inset;\n      }\n    ";
});
var colors = ['red', 'teal', 'blue', 'yellow'];

var NameFrame = function NameFrame(_ref) {
  var name = _ref.name;
  var hash = hashCode(name);
  var initials = getInitials(name);
  var color = colors[hash % colors.length];
  return _react["default"].createElement(_Box["default"], {
    bg: "".concat(color, ".200"),
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }, _react["default"].createElement(_Typography.Text, {
    as: "div",
    color: "".concat(color, ".800")
  }, initials));
};

var Avatar = function Avatar(_ref2) {
  var children = _ref2.children,
      name = _ref2.name,
      src = _ref2.src,
      props = _objectWithoutProperties(_ref2, ["children", "name", "src"]);

  return _react["default"].createElement(Wrap, _extends({
    title: name,
    src: src,
    width: 40,
    height: 40
  }, props), src ? _react["default"].createElement("img", {
    alt: name,
    src: src,
    style: {
      width: '100%',
      height: '100%',
      position: name ? 'absolute' : 'relative'
    }
  }) : '', name ? _react["default"].createElement(NameFrame, {
    name: name
  }) : children);
};

Avatar.defaultProps = {
  theme: _theme["default"],
  fontSize: 3
};

var _default = (0, _styledComponents.withTheme)(Avatar);

exports["default"] = _default;